import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import CaseStudiesPage from "./pages/CaseStudiesPage";
import BlogsPage from "./pages/BlogsPage";
import CaseStudyDetail from "./pages/components/CaseStudyDetail";
import BlogComponent from "./components/BlogComponent";
import Blog2Page from "./pages/Blog2Page";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/case-studies" element={<CaseStudiesPage />} />
          <Route path="/case-study-1" element={<CaseStudyDetail />} />
          <Route path="/blog-1" element={<BlogComponent />} />
          <Route path="/blog-2" element={<Blog2Page />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
